<template>
  <div class="container">
    <div class="handle-box">
      <el-form ref="queryForm" :model="queryForm" label-position="right" label-width="120px" class="searchForm">
        <el-row>
          <el-col :span="24">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item :label="$t('sensory.report.serialNo')" prop="reportNo">
                  <el-input class="handle-input" v-model="queryForm.reportNo" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('sensory.report.name')" prop="fiveBitCodeName">
                  <el-input class="handle-input" v-model="queryForm.fiveBitCodeName" clearable @focus="showTemplateName" @clear='clearFiveBitCodeName' style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('sensory.report.rater')" prop="rater">
                  <el-autocomplete class="inline-input" v-model="queryForm.rater" :fetch-suggestions="querySearch" placeholder="请输入内容" clearable style="width:100%">
                    <el-button slot="append" icon="el-icon-search" @click="searchRater()"></el-button>
                  </el-autocomplete>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="6">
                <el-form-item :label="$t('sensory.report.rateType')" prop="rateType">
                  <IcSelect table="TT_SENSORY" field="RATE_TYPE" v-model="queryForm.rateType" clearable style="width:100%"></IcSelect>
                </el-form-item>
              </el-col> -->
              <el-col :span="6">
                <el-form-item :label="$t('sensory.report.sampleSource')" prop="sampleSource">
                  <IcSelect table="TT_SENSORY" field="SAMPLE_SOURCE" v-model="queryForm.sampleSource" clearable style="width:100%"></IcSelect>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-collapse-transition>
            <el-col :span="24" v-if="isShow">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item :label="$t('sensory.report.status')" prop="status">
                    <IcSelect :excludes="excludesValue" table="TT_SENSORY" field="REPORT_STATUS" v-model="queryForm.status" clearable style="width:100%"></IcSelect>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('nav.plant')" prop="plantName" class="plantName">
                    <pickup-plant v-bind="fiveBitCodeObj" :plantName.sync="queryForm.plantName" style="vertical-align: middle;width:100%"></pickup-plant>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="评估日期(从)" prop="beginDate">
                    <el-date-picker value-format="yyyy-MM-dd" v-model="queryForm.beginDate" type="date" :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="评估日期(至)" prop="endDate">
                    <el-date-picker value-format="yyyy-MM-dd" v-model="queryForm.endDate" type="date" :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <!-- <el-col :span="8">
                  <el-form-item :label="$t('sensory.report.rateDate')" prop="rateDateArr">
                    <el-date-picker ref="rateDatePk" unlink-panels v-model="queryForm.rateDateArr" type="daterange" :range-separator="$t('sensory.report.to')" start-placeholder="开始日期" end-placeholder="结束日期" style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col> -->
                <el-col :span="6">
                  <el-form-item :label="$t('common.remarks')" prop="remark">
                    <el-input class="handle-input" v-model="queryForm.remark" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-collapse-transition>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" type="primary" @click="getData(1)">{{$t("common.search")}}</el-button>
          <el-button size="mini" type="primary" @click="restQueryForm()">{{$t("common.reset")}}</el-button>
          <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
        </el-row>
      </el-form>
    </div>
    <el-row class="action-btn-row">
      <el-button size="mini" class='btn' v-if="emplFlag=='MCD' && !isPickUp" type="primary" v-acl="Sensory-reportNew" @click="newReport">{{$t('sensory.report.addNewSensoryReport')}}</el-button>
      <el-button size="mini" class='btn' v-if="emplFlag=='MCD' && !isPickUp" type="primary" v-acl="Sensory-reportInactive" @click="inactive">Inactive</el-button>
      <el-button size="mini" class='btn' v-if="!isPickUp" type="primary" v-acl="Sensory-reportExport" @click="exportList">总览报表</el-button>
      <el-button size="mini" class='btn' v-if="!isPickUp" type="primary" v-acl="Sensory-reportExport" @click="onExport">详情报表</el-button>
      <el-button size="mini" class='btn' v-if="isPickUp" type="primary" @click="pickUp">{{$t('common.select')}}</el-button>
      <el-button size="mini" class='btn' type="primary" @click="onDel" v-acl="Sensory-ReportDelete">删除</el-button>
      <el-button size="mini" class='btn' v-if="!isPickUp" type="primary" v-acl="Sensory-reportExport" @click="onDetail">详情报告</el-button>

    </el-row>
    <el-table :data="dataList" @selection-change="handleSelectionChange" ref="dataList" border highlight-current-row>
      <el-table-column :fixed="!isPickUp" width="56px" type="selection" :label="$t('common.select')" align="center">
        <!-- <template slot-scope="scope"> -->
        <!-- <el-radio v-model="radioVal" @change="selectRow = scope.row" :label="scope.row.ttSensoryReportId"></el-radio> -->
        <!-- </template> -->
      </el-table-column>
      <el-table-column show-overflow-tooltip :fixed="!isPickUp" :label="$t('sensory.report.serialNo')" prop="reportNo">
        <template slot-scope="scope">
          <el-link v-if="!isPickUp" class="el-link" @click="toDetail(scope.row.ttSensoryReportId)">{{scope.row.reportNo}}</el-link>
          <span v-if="isPickUp">{{scope.row.reportNo}}</span>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip :label="$t('sensory.report.name')" prop="fiveBitCodeName"></el-table-column>
      <el-table-column show-overflow-tooltip :label="$t('sensory.report.rater')" prop="rater"></el-table-column>
      <!-- <el-table-column show-overflow-tooltip :label="$t('sensory.report.rateType')" prop="rateType">
        <template slot-scope="scope">{{scope.row.rateType | ic("TT_SENSORY","RATE_TYPE")}}</template>
      </el-table-column> -->
      <el-table-column show-overflow-tooltip :label="$t('sensory.report.rateDate')" prop="rateDate">
        <template slot-scope="scope">{{scope.row.rateDate | dateFormatFilter("YYYY-MM-DD")}}</template>
      </el-table-column>
      <el-table-column show-overflow-tooltip :label="$t('sensory.report.sampleSource')" prop="sampleSource" min-width="100">
        <template slot-scope="scope">{{scope.row.sampleSource | ic("TT_SENSORY","SAMPLE_SOURCE")}}</template>
      </el-table-column>
      <el-table-column show-overflow-tooltip :label="$t('sensory.report.status')" prop="status">
        <template slot-scope="scope">{{scope.row.status | ic("TT_SENSORY","REPORT_STATUS")}}</template>
      </el-table-column>
      <el-table-column show-overflow-tooltip :label="$t('common.remarks')" prop="remark"></el-table-column>
      <el-table-column show-overflow-tooltip label="模板名称" prop="templateName" width="150px"></el-table-column>
      <el-table-column show-overflow-tooltip label="版本" prop="templateVersion" width="70px"></el-table-column>

      <el-table-column show-overflow-tooltip :label="$t('common.createDate')" prop="createDate">
        <template slot-scope="scope">{{scope.row.createDate | dateFormatFilter("YYYY-MM-DD")}}</template>
      </el-table-column>
      <el-table-column show-overflow-tooltip :label="$t('common.createBy')" prop="creator" min-width="120"></el-table-column>
      <el-table-column show-overflow-tooltip v-if="queryForm.status == 'CANCLE'" :label="$t('sensory.report.invalidReason')" prop="inactiveReason"></el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination :page-sizes="[10,15,50,100]" @size-change="pageSizeChange($event,'queryForm','getData')" :page-size="queryForm.pageSize" :current-page="queryForm.pageNum" @current-change="pageNumberChange($event,'queryForm','getData')" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
    <el-dialog :visible.sync="showRaterDialog" append-to-body width="80%" title="评估人选择器">
      <pickupUser @input="selectRater" :multi="true"></pickupUser>
    </el-dialog>
    <el-dialog :visible.sync="showTemplateNameDialog" append-to-body width="80%" title="产品选择器">
      <PickupFiveBitCode @pickup="selectTemplateName" v-if="TemplateNameDialogReset"></PickupFiveBitCode>
    </el-dialog>
  </div>
</template>

<script>
import IcSelect from "@/components/common/icSelect";
import pickupUser from "@/components/page/sensory/sensory-template/choiceUser";
import dataTableUtils from "@/utils/dataTableUtils";
import report from "@/api/sensory/report";
import commonFun from "@/utils/commonFun";
import { fileService } from "@/api/common/file-utils";
import { Message } from "element-ui";
import PickupPlant from "@/components/page/sensory/pickupPlant";
import PickupFiveBitCode from "@/components/page/sensory/sensory-template/templateName";
import fiveBitCode from "@/api/base-data/fiveBitCode";
import store from '@/store/index';
import paginationMixin from '@/mixins/pagitionMixin';
export default {
  mixins: [paginationMixin],
  name: "sensory-report-list",
  components: { PickupFiveBitCode, PickupPlant, pickupUser, IcSelect },
  props: {
    action: String,
    fiveBitCodeName: String,
    fiveBitCode: String,
  },
  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      emplFlag: null,
      excludesValue: [],
      queryForm: {
        pageSize: 15,
        pageNum: 1,
        rater: '',
        reportNo: '',
        fiveBitCodeName: '',
        plantName: "",
        remark: '',
        // rateType: "",
        sampleSource: "",
        status: "",
        beginDate: "",
        endDate: "",
        // rateDateArr: [],
      },
      TemplateNameDialogReset: false,
      fiveBitCodeObj: {},
      total: null,
      dataList: [],
      showTemplateNameDialog: false,
      showRaterDialog: false,
      username: '',
      multipleSelection: [],
      ttSensoryReportIdLists: [],
    }
  },
  computed: {
    isPickUp() {
      return this.action == 'pickUp';
    }
  },
  extends: dataTableUtils,
  watch: {
    queryForm() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryForm })
    }
  },
  beforeRouteEnter(to, from, next) {
    console.log('to', to);
    console.log('from', from);
    next(vm => {
      vm.queryForm = to.meta.reqData;
      // if (to.query.facilityCode) {
      //   vm.queryForm.plantName = to.query.facilityCode
      // }
      if (to.query.ttQspiFacilityFactorScoreId) {
        vm.queryForm.ttQspiFacilityFactorScoreId = to.query.ttQspiFacilityFactorScoreId
      }
      vm.getData();
    })
  },
  created() {
    if (this.action == 'pickUp') {
      this.getData();
    }
    this.username = localStorage.getItem("ms_username");
    this.emplFlag = localStorage.getItem("ms_emplFlag");
    this.queryForm.fiveBitCodeName = this.isPickUp ? this.fiveBitCodeName : ''
    //非供应商用户不显示草稿状态
    if (this.emplFlag == 'SUP') {
      this.excludesValue = ['DRAFT', 'CANCLE'];
    }
  },
  methods: {
    handleSelectionChange(val) {
      console.log("GY🚀 ~ handleSelectionChange ~ val:", val);
      this.multipleSelection = val
      this.ttSensoryReportIdLists = val.map(ele => ele.ttSensoryReportId)
    },
    onDel() {
      // 重写
      if (this.multipleSelection.length == 0) {
        this.$message.error('请至少选择一条数据')
        return false
      }
      if (this.multipleSelection.length > 1) {
        this.$message.error('只能选择一条数据')
        return false
      }

      if (this.multipleSelection[0].status !== 'DRAFT') {
        this.$message.error("业务数据错误：请确认勾选的数据状态都为草稿!")
        return false
      }
      this.$confirm('是否确定删除此条数据?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        report.deleteReportForDraft(this.multipleSelection[0].ttSensoryReportId).then(resp => {
          console.log("🚀 ~ file: sensoryReportList.vue ~ line 232 ~ report.deleteReportForDraft ~ resp", resp)
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.getData()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    showTemplateName() {
      this.showTemplateNameDialog = true;
      this.TemplateNameDialogReset = true
    },
    selectTemplateName(list) {
      this.fiveBitCodeObj = list;
      let that = this;
      that.queryForm.fiveBitCodeName = list.fiveBitCodeName;
      that.queryForm.fiveBitCode = list.fiveBitCode;
      this.showTemplateNameDialog = false;
    },
    getData(val) {
      let that = this
      if (undefined != val) {
        this.queryForm.pageNum = 1;
      }
      report.queryReport(this.queryForm).then(resp => {
        this.total = resp.totalCount;
        this.dataList = resp.resultData;
      })
      if (this.fiveBitCode) {
        fiveBitCode.getDetail(this.fiveBitCode).then(res => {
          that.fiveBitCodeObj = {
            categoryLevel1Code: res.data.categoryLevel1Code,
            categoryLevel2Code: res.data.categoryLevel2Code,
            categoryLevel3Code: res.data.categoryLevel3Code,
            fiveBitCode: res.data.fiveBitCode,
            fiveBitCodeName: res.data.fiveBitCodeName,
          }
        })
      }
    },
    newReport() {
      this.$router.push({ name: "newSensoryReport" });
    },
    inactive() {
      // let that = this;
      // 重写
      // let selection = this.selectRow;
      // if (commonFun.isEmpty(selection)) {
      //   Message.warning(this.$t("common.pleaseSelectOneData"));
      //   return;
      // }
      if (this.multipleSelection.length == 0) {
        this.$message.error('请至少选择一条数据')
        return false
      }
      if (this.multipleSelection.length > 1) {
        this.$message.error('只能选择一条数据')
        return false
      }
      if (this.multipleSelection[0].status == 'CANCLE') {//已经作废了
        this.$message.warning(this.$t("common.Voided"));
        return;
      }
      if (this.username != this.multipleSelection[0].creator) {//操作的不是自己的数据
        if (this.actionCheck.actionCheck('SENSORY_ADMIN') === false) {//没勾 品评报告管理员 权限
          this.$message({ message: this.$t('common.onlyOperateOwn'), type: "warning" });
          return false
        }
      }
      this.$prompt(this.$t("sensory.report.pleaseEnterTheReason"), 'Inactive', {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        customClass: 'colorBtn',
        inputValidator: (val) => {
          if (val === null) {
            return this.$t('sensory.report.ReasonCannotEmpty');
          }
          return val.length < 300
        },
        inputErrorMessage: this.$t("sensory.report.reasonTooLong")
      }).then(msg => {
        if (commonFun.isEmpty(msg.value)) {
          this.$message(this.$t('sensory.report.ReasonCannotEmpty'));
          return;
        }
        report.inactive(this.multipleSelection[0].ttSensoryReportId, msg.value).then(res => {
          this.getData()
        }

        );
      }).catch(() => {
      });
    },
    pickUp() {
      // 重写
      if (this.multipleSelection.length == 0) {
        this.$message.error('请至少选择一条数据')
        return false
      }
      if (this.multipleSelection.length > 1) {
        this.$message.error('只能选择一条数据')
        return false
      }
      // let rows = this.selectRow;
      // if (commonFun.isEmpty(rows)) {
      //   Message.warning("common.pleaseSelectOneData");
      //   return;
      // } else {
      this.$emit("pickUp", rows);
      // }
    },
    exportList() {
      let that = this;
      report.exportList(that.queryForm).then(fileService.respToFile);
    },
    onExport() {
      if (this.multipleSelection.length == 0) {
        this.$message.error('请至少选择一条数据')
        return false
      }
      if (this.multipleSelection.length > 1) {
        this.$message.error('只能选择一条数据')
        return false
      }
      // if (!this.radioVal) {
      //   this.$message.error('请选择一条数据导出')
      //   return false
      // }
      report.exportDetail(this.multipleSelection[0].ttSensoryReportId).then(fileService.respToFile);
    },
    onDetail() {
      if (this.multipleSelection.length == 0) {
        this.$message.error('请至少选择一条数据')
        return false
      }
      report.exportPrintExcel(this.ttSensoryReportIdLists).then(fileService.respToFile);
    },
    searchRater() {
      this.showRaterDialog = true
    },
    selectRater(list) {
      let that = this
      if (list.length > 0) {
        that.queryForm.rater = list.map(data => data.name).join(',');
      }
      that.showRaterDialog = false
    },
    querySearch(queryString, cb) {
      var restaurants = [{ value: "QA LAB" }];
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      cb(results);
    },
    createFilter(queryString) {
      return restaurant => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    toDetail(id) {
      if (this.actionCheck.actionCheck('Sensory-reportQueryDetailByReportId') === false) {
        this.$message.error(this.$t('common.noPermission'))
        return false
      }
      let resolve = this.$router.resolve({
        path: `/sensoryReport-edit/${id}`
      });
      window.open(resolve.href, "_blank");
    },
    //查询条件重置方法
    restQueryForm: function () {
      this.$refs.queryForm.resetFields();
      this.fiveBitCodeObj = {};
      this.queryForm = {
        pageSize: 15,
        pageNum: 1,
        rater: '',
        reportNo: '',
        fiveBitCodeName: '',
        plantName: "",
        remark: '',
        // rateType: "",
        sampleSource: "",
        status: "",
        beginDate: "",
        endDate: "",
      }
      this.getData();
    },
    clearFiveBitCodeName() {
      this.fiveBitCodeObj = {}
      this.fiveBitCode = ''
      this.fiveBitCodeName = ''
      this.TemplateNameDialogReset = false
      this.$nextTick(() => {
        this.TemplateNameDialogReset = true
      })
    }
  },
}
</script>

<style scoped lang="scss">
.el-select {
  width: 100%;
}
.el-date-editor--daterange.el-input__inner {
  width: auto;
}

.el-date-editor--daterange.el-input__inner {
  width: auto;
}

.el-table > .el-table__fixed-right {
  height: 100% !important; //设置高优先，以覆盖内联样式
}
.colorBtn .el-button {
  background: #f8ab01 !important;
  color: #fff !important;
  border-color: #f8ab01 !important;
}
.el-link {
  text-decoration: underline;
  color: #f8ab01 !important;
  cursor: pointer;
  font-size: 12px;
}
</style>
<style lang="scss">
.sensoryReportList {
  .queryForm {
    .el-form-item__content {
      .handle-input {
        width: 100%;
      }
      .el-autocomplete {
        width: 100%;
      }
      .el-date-editor {
        width: 100%;
      }
    }
  }
}
</style>
